export enum MenuPositionType {
  ITEM = 'ITEM',
  COMBO = 'COMBO',
  ADDON = 'ADDON',
}
